import {
  ADD_LICENSE,
  ADD_LICENSE_SUCCESSFUL,
  ADD_LICENSE_FAILED,
  GET_LICENSE,
  GET_LICENSE_SUCCESSFUL,
  GET_LICENSE_FAILED,
  UPDATE_LICENSE,
  UPDATE_LICENSE_SUCCESSFUL,
  UPDATE_LICENSE_FAILED,
  ADD_COMPLIANCE_ADDONS,
  ADD_COMPLIANCE_ADDONS_SUCCESSFUL,
  ADD_COMPLIANCE_ADDONS_FAILED,
  DELETE_LICENSE,
  DELETE_LICENSE_SUCCESSFUL,
  DELETE_LICENSE_FAILED,
  CLEAR_ALL_MESSAGES,
  CLEAR_ALL_MESSAGES_SUCCESS,
  CLEAR_SUCCESS_MESSAGES,
  CLEAR_SUCCESS_MESSAGES_SUCCESS,
  CLEAR_FAILURE_MESSAGES,
  CLEAR_FAILURE_MESSAGES_SUCCESS,
} from "./actionTypes";

export const addLicense = (license) => {
  console.log("Actions :: ", license);
  return {
    type: ADD_LICENSE,
    payload: { license },
  };
};

export const addLicenseSuccessful = (license) => {
  console.log("Is Success Called");
  return {
    type: ADD_LICENSE_SUCCESSFUL,
    payload: { license },
  };
};

export const addLicenseFailed = (error) => {
  console.log("Is error called", error.response.data);
  return {
    type: ADD_LICENSE_FAILED,
    payload: { error },
  };
};

export const getLicense = (orgCode) => {
  console.log("hello again");
  return {
    type: GET_LICENSE,
    payload: { orgCode },
  };
};

export const getLicenseSuccessful = (license) => {
  console.log("hello", license);
  return {
    type: GET_LICENSE_SUCCESSFUL,
    payload: { license },
  };
};

export const getLicenseFailed = (error) => {
  return {
    type: GET_LICENSE_FAILED,
    payload: error,
  };
};

export const updateLicense = (license) => {
  console.log("actions -> updateLicense() called with ", license);
  return {
    type: UPDATE_LICENSE,
    payload: { license },
  };
};

export const updateLicenseSuccessful = (license) => {
  return {
    type: UPDATE_LICENSE_SUCCESSFUL,
    payload: { license },
  };
};

export const updateLicenseFailed = (error) => {
  return {
    type: UPDATE_LICENSE_FAILED,
    payload: { error },
  };
};

export const addComplianceAddons = (complianceAddons) => {
  console.log("actions -> addComplianceAddons() called with ", complianceAddons);
  return {
    type: ADD_COMPLIANCE_ADDONS,
    payload: { complianceAddons },
  };
}

export const addComplianceAddonsSuccessful = () => {
  console.log(
    "actions -> addComplianceAddonsSuccessful() called");
  return {
    type: ADD_COMPLIANCE_ADDONS_SUCCESSFUL,
  };
};

export const addComplianceAddonsFailed = (error) => {
  console.log("actions -> addComplianceAddonsFailed() called with error = ", error);
  return {
    type: ADD_COMPLIANCE_ADDONS_FAILED,
    payload: { error }
  };
};

export const deleteLicense = (license) => {
  console.log("actions -> deleteLicense() called with ", license);
  return {
    type: DELETE_LICENSE,
    payload: { license },
  };
};

export const deleteLicenseSuccessful = (license) => {
  return {
    type: DELETE_LICENSE_SUCCESSFUL,
    payload: { license },
  };
};

export const deleteLicenseFailed = (error) => {
  return {
    type: DELETE_LICENSE_FAILED,
    payload: { error },
  };
};

export const clearAllGlobalLicenseMessages = () => {
  return {
    type: CLEAR_ALL_MESSAGES,
    payload: {},
  };
};

export const clearAllGlobalLicenseMessagesSuccess = () => {
  return {
    type: CLEAR_ALL_MESSAGES_SUCCESS,
    payload: {},
  };
};

export const clearSuccessGlobalLicenseMessages = () => {
  return {
    type: CLEAR_SUCCESS_MESSAGES,
    payload: {},
  };
};

export const clearSuccessGlobalLicenseMessagesSuccess = () => {
  return {
    type: CLEAR_SUCCESS_MESSAGES_SUCCESS,
    payload: {},
  };
};

export const clearFailureGlobalLicenseMessages = () => {
  return {
    type: CLEAR_FAILURE_MESSAGES,
    payload: {},
  };
};

export const clearFailureGlobalLicenseMessagesSuccess = () => {
  return {
    type: CLEAR_FAILURE_MESSAGES_SUCCESS,
    payload: {},
  };
};

